import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
  key: 1,
  class: "agreement-iframe-wrap"
};
const _hoisted_3 = ["src"];
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AgreementView',
  props: {
    show: {
      type: Boolean
    },
    message: null,
    messageUrl: null
  },
  emits: ['update:show', 'close'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const handleClose = () => {
      emits('update:show', false);
      emits('closeDialog');
    };
    const dialogShow = computed({
      get: () => {
        return props.show;
      },
      set: value => {
        emits('update:show', value);
      }
    });
    return (_ctx, _cache) => {
      const _component_van_dialog = _resolveComponent("van-dialog");
      return _openBlock(), _createBlock(_component_van_dialog, {
        class: "main-agreement-view",
        show: _unref(dialogShow),
        "onUpdate:show": _cache[0] || (_cache[0] = $event => _isRef(dialogShow) ? dialogShow.value = $event : null),
        "before-close": handleClose,
        "confirm-button-text": "阅读完毕",
        "lock-scroll": true
      }, {
        default: _withCtx(() => [props.message && __props.show ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "agreementContent",
          class: "agreement-wrap",
          innerHTML: props.message
        }, null, 8, _hoisted_1)) : _createCommentVNode("", true), props.messageUrl ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("iframe", {
          src: props.messageUrl,
          frameborder: "0",
          width: "100%",
          height: "100%"
        }, null, 8, _hoisted_3)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["show"]);
    };
  }
});